import { Elements } from '@stripe/react-stripe-js';

import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY } from '../../../../../config';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

function StripeContext({ children }: { children: React.ReactNode }) {
    return <Elements stripe={stripePromise}> {children}</Elements>;
}
export default StripeContext;
